import { GetProductsOfRoomsByFloorsRoom } from "src/model/api/v2/data-contracts";
import { ts, ts2 } from "src/utils/translate";
import { useDeleteRoomMutation } from "src/api/v1/floor-ApiSlice";
import { BaseDialog } from "src/components/BaseDialog/BaseDialog";
import { useAppDispatch, useAppSelector } from "src/app/hooks";
import { plannerUiSlice } from "src/api/planner-ui-slice";
import { showSnackBar } from "src/api/ui-slice";
import { deleteRoomFromPlannerWithHistory, isPredefinedRoom } from "src/pages/PlannerPage/FloorView/floorViewActions";

interface DeleteRoomDialogProps {
  onClose: () => void,
  room: GetProductsOfRoomsByFloorsRoom | null
}

export const DeleteRoomDialog = ({onClose, room}: DeleteRoomDialogProps) => {
  const [deleteRoom] = useDeleteRoomMutation();
  const dispatch = useAppDispatch();
  const selectedRoom = useAppSelector((state) => state.plannerUi.selectedRoom);

  return (
      <BaseDialog
          onClose={onClose}
          title={ts('planner_room_deletion_dialog_title', "Delete Room?")}
          cancelLabel={ts("planner_deletion_dialog_cancel_button_text", "Cancel")}
          actionLabel={ts("planner_deletion_dialog_action_button_text", "Delete")}
          onAction={() => {
            const roomId = room!!.room_id;
            if (isPredefinedRoom(roomId)) {
              dispatch(showSnackBar({
                text: ts('planner_cannot_delete_room', "This room can't be deleted"),
                severity: 'error',
              }));
              onClose();
              return;
            }
            deleteRoom(roomId).unwrap()
            .then(() => {
              deleteRoomFromPlannerWithHistory(roomId);
              if (selectedRoom.id === roomId) {
                dispatch(plannerUiSlice.actions.setSelectedRoom({ id: null }));
                dispatch(plannerUiSlice.actions.setSelectedDevice({
                  productNameId: null,
                  productId: null,
                }));
              }
            })
            .catch(() => {
              dispatch(showSnackBar({
                text: ts('planner_room_deletion_error', 'Failed to delete room'),
                severity: 'error',
              }));
            });
            onClose()
          }}
      >
        {ts2('planner_room_deletion_dialog_content', "Are you sure you want to delete the {roomName} room?", {
          roomName: room?.room_name ?? ''
        })}
      </BaseDialog>
  )
}